import axios from "axios";

import Config from "../../config";

const actionEditarWebhook = (webhookId, data) => {

    return axios({
        method: "put",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/clientes/cliente/integracoes/webhooks/${webhookId}/editar`,
        data
    });
};

export default actionEditarWebhook;
